<template>
  <div>
    <p>{{ $t("GenerateCatalogFromTextFile.CatalogNaming.Part1") }}</p>
    <p>
      <b-input v-tooltip="validation ? errorMsg : ''" v-model="name" :class="{ 'border-danger': validation }" @keyup="validate" />
    </p>
    <p class="mb-0">
      {{
        $t("GenerateCatalogFromTextFile.CatalogNaming.Continue", {
          BackButton: $t("Back"),
          ContinueButton: $t("Continue")
        })
      }}
    </p>
    <div class="catalog-modal-buttons">
      <b-btn
        class="mr-2"
        @click="
          $emit('stepChange', {
            currentState: 'CatalogNaming',
            nextState: 'CatalogOptions'
          })
        "
        >{{ $t("Back") }}</b-btn
      >
      <b-btn
        @click="
          $emit('stepChange', {
            currentState: 'CatalogNaming',
            nextState: 'CatalogFinishing',
            catalogName: name
          })
        "
        :disabled="validation || !name"
        >{{ $t("Continue") }}</b-btn
      >
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      name: "",
      validation: false,
      errorMsg: ""
    };
  },
  methods: {
    validate() {
      const maxStringLength = 256;

      this.errorMsg = "";
      this.validation = false;

      if (this.name.length <= 0) {
        this.validation = true;
        this.errorMsg = this.$t("ErrorMessage.Mandatory");
      }

      if (this.name.length > maxStringLength) {
        this.validation = true;
        this.errorMsg = this.$t("ErrorMessage.Max256");
      }
    }
  }
};
</script>
